module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Brassiere-035831e880af1902359f538d2fb0ffd8.svg";